import ProtectedRoute from ".";

export default function withProtected(element: JSX.Element) {
  return <ProtectedRoute>{element}</ProtectedRoute>;
}
